import  axiosInstance  from "../utils/api";

import endpoints
 from "../constants/endpoints";

export const AdminUserAPI = {

    getListOfAdminUsers: async () => {
        try {
            const response = await axiosInstance.get(`${endpoints.fetchListOfAdmins}`);
            return response.data; // Expecting array of user objects
        } catch (error) {
            throw new Error('Failed to fetch users: ' + error.message);
        }
    },

    searchAminUserAccounts: async (formData) => {
        try {
            const response = await axiosInstance.post(`${endpoints.searchAndFilterAdminUsers}`, formData);
            return response.data; // Expecting array of user objects
        } catch (error) {
            throw new Error('Failed to fetch users: ' + error.message);
        }
    },

    registerAdminUser: async (formData) => {
        try {
            const response = await axiosInstance.post(`${endpoints.registerNewAccount}`, formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            return response.data; // Expecting array of user objects
        } catch (error) {
            throw new Error('Failed to fetch users: ' + error.message);
        }
    },

    updateAdminUser: async (formData) => {
        try {
            const response = await axiosInstance.put(`${endpoints.updateAdminUser}`, formData, 
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            return response.data; // Expecting array of user objects
        } catch (error) {
            throw new Error('Failed to fetch users: ' + error.message);
        }
    },

    fetchAdminUser: async (id) => {
        try {
            const response = await axiosInstance.get(`${endpoints.fetchSingleAdminUser(id)}`);
            return response.data; // Expecting array of user objects
        } catch (error) {
            throw new Error('Failed to fetch users: ' + error.message);
        }
    },

}

